import { gql } from "@apollo/client";

export const LIST_COMPANIES = gql`
  query listCompanies(
    $limit: Int
    $offset: Int
    $nameContains: String
    $orderBy: [String!]
    $vatNumberStartswith: ID
  ) {
    listCompanies(
      filter: { name_Contains: $nameContains, vatNumber_Startswith: $vatNumberStartswith }
    ) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        name
        vatNumber
        legalCategory
        businessActivity
        establishments {
          addressNr
          address
          address2
          postalCode
          township
        }
      }
    }
  }
`;
